import { render } from "./formMessageEditor.vue?vue&type=template&id=4efbbae4"
import script from "./formMessageEditor.vue?vue&type=script&lang=js"
export * from "./formMessageEditor.vue?vue&type=script&lang=js"

import "./formMessageEditor.vue?vue&type=style&index=0&id=4efbbae4&lang=scss"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__